import { MessageTimeProps } from "./types"
import React from "react"
import styled from '~/ui/styled'
import { formatMessageTime } from "~/utils"

const Text = styled.Text<Pick<MessageTimeProps, "color">>`
  color: ${({ theme, color }) => color || theme.colors.secondaryText};
  font-size: ${({ theme }) => theme.fontSizes.sm};
`

const MessageTime: React.FC<MessageTimeProps> = ({ time, color }) => {
  return <Text color={color}>{formatMessageTime(time)}</Text>
}

export default MessageTime
